import React from 'react';
import auth from '../../api/auth';
import MediaQuery from 'react-responsive';
import { NavLink } from 'react-router-dom'
import MenuItems from './menu_items'

class MenuTop extends React.Component{
    desktop_menu() {
        return (
            <MediaQuery minWidth={701} className="menu_wrap">
                <div className="menu_wrap">
                    <MenuItems/>
                </div>
            </MediaQuery>
        )
    }
    showMenuMobile() {
        this.props.history.push('/menumobile');
    }
    mobile_menu() {
        return (
            <MediaQuery maxWidth={700} className="menu-top-dropdown">
                <div className="menu-top-dropdown">
                <NavLink activeClassName={"active_menu"} to="/menumobile">
                        <div className="dropdown_icon"></div>
                        <div className="dropdown_icon"></div>
                        <div className="dropdown_icon"></div>
                    </NavLink>
                </div>
            </MediaQuery>
        )
    }
    render() {
        if (!auth.isAuth()) {
            return null;
        } else {
            return (
                <div>
                {this.mobile_menu()}
                {this.desktop_menu()}
                </div>
            )
        }
    }
}

export default MenuTop;
